module.exports = __webpack_public_path__ + "img/hat_1.4e519694.png";